export default __webpack_public_path__ + "img/dKkWrekj.c7f45cad.svg";